document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-notify-form]').forEach(function (formEl) {
    var publicKey = formEl.getAttribute('data-public-key');
    var emailInput = formEl.querySelector('[data-notify-email]');
    var submitBtn = formEl.querySelector('[data-notify-submit]');
    var messageEl = formEl.querySelector('[data-notify-message]');

    submitBtn.addEventListener('click', function () {
      var email = emailInput.value.trim();
      if (!email) return;

      if (!publicKey) {
        messageEl.textContent = 'Notify signup is not configured yet.';
        messageEl.hidden = false;
        return;
      }

      submitBtn.disabled = true;
      var originalLabel = submitBtn.textContent;
      submitBtn.textContent = '...';

      var profileAttrs = { email: email };
      if (window.fantasyAveKlaviyoAnonId) {
        var anonId = window.fantasyAveKlaviyoAnonId();
        if (anonId) profileAttrs.anonymous_id = anonId;
      }

      fetch('https://a.klaviyo.com/client/events/?company_id=' + publicKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: {
                ProductTitle: formEl.getAttribute('data-product-title'),
                ProductURL: window.location.origin + formEl.getAttribute('data-product-url'),
                VariantId: formEl.getAttribute('data-variant-id')
              },
              metric: {
                data: {
                  type: 'metric',
                  attributes: { name: 'Back in Stock Request' }
                }
              },
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttrs
                }
              }
            }
          }
        })
      })
        .then(function (res) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
          if (res.ok || res.status === 202) {
            formEl.querySelector('.notify-back-in-stock__row').hidden = true;
            messageEl.textContent = "You're on the list — we'll email you when it's back.";
            messageEl.hidden = false;
          } else {
            messageEl.textContent = 'Something went wrong, please try again.';
            messageEl.hidden = false;
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
          messageEl.textContent = 'Something went wrong, please try again.';
          messageEl.hidden = false;
        });
    });
  });
});
